"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledAccordion = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject;

var _default = {};
exports["default"] = _default;

var StyledAccordion = _styledComponents["default"].dl.withConfig({
  displayName: "AccordionWorkflowstyles__StyledAccordion",
  componentId: "sc-1yps1s4-0"
})(["", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n  "])), function (_ref) {
  var accordion = _ref.theme.accordion;
  return accordion === null || accordion === void 0 ? void 0 : accordion.accordion;
}));

exports.StyledAccordion = StyledAccordion;